import React from 'react';
import { Service } from '../../types/service';

export const servicesData: Service[] = [
  {
    title: 'Valutazione Posturale',
    icon: '📊',
    shortDesc:
      'Analisi approfondita della postura per individuare eventuali squilibri.',
    features: [
      'Analisi completa della postura',
      'Test di movimento e flessibilità',
      'Relazione dettagliata personalizzata',
      'Consigli specifici per il tuo caso',
    ],
    longDesc: (
      <div className="modal-content-custom">
        <div className="alert alert-success mb-4">
          <i className="bi bi-star-fill me-2"></i>
          <strong>Il primo passo verso il tuo benessere!</strong>
        </div>

        <div className="mb-3">
          <button
            className="btn btn-secondary px-4"
            onClick={() =>
              window.open(
                'https://wa.me/3757481380',
                '_blank',
                'noopener,noreferrer'
              )
            }
          >
            <i className="bi bi-calendar-check me-2"></i>
            Prenota ora
          </button>
        </div>

        <p className="text-body">
          È il primo passo che ti porta più lontano dai tuoi dolori abituali e
          più vicino ad una conoscenza che sarà <strong>per sempre tua</strong>,
          grazie alla quale ti renderai conto da sola in ogni momento se sei
          allineata o se il tuo corpo sta "adagiando" la sua postura, mettendo
          le basi per nuovi dolori e nuovi problemi che si faranno sentire nel
          prossimo futuro (ahi ahi ahi!).
        </p>

        <div className="row mt-4 mb-4">
          <div className="col-md-6 mb-3">
            <div className="card border-body h-100">
              <div className="card-header bg-body-tertiary text-body-emphasis d-flex align-items-center">
                <i className="bi bi-eye me-2"></i>
                <strong>Osservazione</strong>
              </div>
              <div className="card-body">
                <p className="card-text small mb-0 text-body">
                  Analisi della postura abituale e rilevamento dei difetti che
                  emergono durante l'allineamento del corpo
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="card border-body h-100">
              <div className="card-header bg-body-tertiary text-body-emphasis d-flex align-items-center">
                <i className="bi bi-activity me-2"></i>
                <strong>Test di Movimento</strong>
              </div>
              <div className="card-body">
                <p className="card-text small mb-0 text-body">
                  Valutazione del grado di flessibilità, ampiezza dei movimenti
                  e identificazione dei limiti funzionali
                </p>
              </div>
            </div>
          </div>
        </div>

        <h6 className="text-body-emphasis fw-bold mt-4 mb-3">
          <i className="bi bi-target me-2"></i>
          Dopo un'attenta valutazione potrò indicarti la strategia migliore per:
        </h6>

        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="card border-body h-100">
              <div className="card-header bg-body-tertiary text-body-emphasis">
                <i className="bi bi-heart-pulse me-2"></i>
                <strong>Correzione Funzionale</strong>
              </div>
              <div className="card-body">
                <p className="card-text small mb-0 text-body">
                  Correggere eventuali difetti che già causano dolori o che
                  potrebbero causarne più avanti
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="card border-body h-100">
              <div className="card-header bg-body-tertiary text-body-emphasis">
                <i className="bi bi-person-check me-2"></i>
                <strong>Consulenza d'Immagine Posturale</strong>
              </div>
              <div className="card-body">
                <p className="card-text small mb-0 text-body">
                  Correggere i difetti posturali anti-estetici per migliorare la
                  tua immagine e aumentare l'auto-stima
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="alert alert-primary mt-4">
          <h6 className="fw-bold mb-2">
            <i className="bi bi-diagram-3 me-2"></i>
            Approccio Globale e Integrato
          </h6>
          <p className="mb-0">
            La strategia tiene sempre in considerazione il{' '}
            <strong>sistema corpo nel suo complesso</strong>: muscoli, sistema
            scheletrico, respiratorio, nervoso, emotivo... tutto è collegato!
          </p>
        </div>

        <div className="row mt-4">
          <div className="col-12">
            <div className="card border-body h-100">
              <div className="card-header bg-body-tertiary text-body-emphasis">
                <i className="bi bi-award me-2"></i>
                <strong>Le Mie Competenze</strong>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-6">
                    <ul className="list-unstyled small mb-0">
                      <li className="text-body">
                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                        Terapista Pancafit
                      </li>
                      <li className="text-body">
                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                        Naturopata
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul className="list-unstyled small mb-0">
                      <li className="text-body">
                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                        Insegnante di Yoga
                      </li>
                      <li className="text-body">
                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                        Istruttrice Mammafit
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-4 p-3 bg-body-secondary rounded">
          <h6 className="text-body-emphasis fw-bold">Tariffe:</h6>

          {/* Badge per modalità disponibili */}
          <div className="text-center mb-3">
            <span className="badge bg-success px-3 py-2 me-2">
              <i className="bi bi-person-check me-1"></i>
              In presenza
            </span>
            <span className="badge bg-primary px-3 py-2">
              <i className="bi bi-camera-video me-1"></i>
              Online
            </span>
          </div>

          <div className="tariffe-list">
            {/* Singola seduta - BIANCO */}
            <div className="tariffa-item mb-3 p-3 bg-white rounded shadow-sm">
              <div className="d-flex justify-content-between align-items-center">
                <span className="fw-semibold text-dark">Singola seduta</span>
                <span className="fw-bold text-body-emphasis fs-5">€ 60,00</span>
              </div>
              <small className="text-muted">(in presenza o online)</small>
            </div>
          </div>

          <div className="mt-3 text-center">
            <button
              className="btn btn-secondary px-4"
              onClick={() =>
                window.open(
                  'https://wa.me/3757481380',
                  '_blank',
                  'noopener,noreferrer'
                )
              }
            >
              <i className="bi bi-calendar-check me-2"></i>
              Prenota ora
            </button>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: 'Percorso di Riequilibrio Posturale con Pancafit e Chair',
    icon: '🪑',
    shortDesc:
      'Sedute personalizzate di riequilibrio posturale con strumenti specifici.',
    features: [
      'Tecnica Pancafit professionale',
      'Utilizzo sedia ergonomica',
      'Riequilibrio muscolare globale',
      'Miglioramento della respirazione',
    ],
    longDesc: (
      <div className="modal-content-custom">
        <div className="alert alert-success mb-4">
          <i className="bi bi-star-fill me-2"></i>
          <strong>Conquista il tuo Benessere con facilità e competenza</strong>
        </div>

        <div className="mb-3">
          <button
            className="btn btn-secondary px-4"
            onClick={() =>
              window.open(
                'https://wa.me/3757481380',
                '_blank',
                'noopener,noreferrer'
              )
            }
          >
            <i className="bi bi-calendar-check me-2"></i>
            Prenota ora
          </button>
        </div>

        <p className="text-body">
          Ogni seduta è personalizzata in base a quanto emerge dalla valutazione
          posturale.
        </p>

        <p className="text-body">
          Tuttavia nella prima seduta è indispensabile affrontare l'approccio
          con la respirazione, dal momento che il diaframma (il muscolo deputato
          alla respirazione) è un muscolo di grandi dimensioni, posto al centro
          del corpo e correlato alle principali strutture che determinano
          l'assetto posturale. Non è possibile avere un approccio globale e
          integrato senza intervenire sulla funzionalità del diaframma.
        </p>

        <p className="text-body">
          Bisogna sapere inoltre che il diaframma è il principale muscolo
          coinvolto negli effetti dello stress, perciò andando a lavorare su di
          esso, anche gli effetti dello stress possono avere un notevole
          miglioramento.
        </p>

        <p className="text-body">
          Durante le sedute si userà la <strong>Pancafit</strong> quale
          strumento di riequilibrio posturale ad approccio globale, ma per
          favorire il rilassamento di una muscolatura troppo tesa, potrei
          procedere prima con alcuni minuti di utilizzo della{' '}
          <strong>sedia ergonomica</strong>, sulla quale il corpo si rilassa e
          la schiena si dice che resta in completo scarico, ovvero tutta la
          muscolatura dorsale, lombare e cervicale si rilascia completamente. Di
          conseguenza il respiro si libera, perciò questi minuti diventano
          preziosi anche per il diaframma.
        </p>

        <p className="text-body">
          In base alla strategia individuata in fase di valutazione gli esercizi
          o il trattamento proseguirà di seduta in seduta fino a quando i
          benefici si faranno sentire alleviando o eliminando completamente i
          dolori o liberando i movimenti. In base alla mia esperienza ciò
          succede entro le <strong>5 sedute</strong>, ma dipende da caso a caso.
        </p>

        <div className="mt-4 p-3 bg-body-secondary rounded">
          <h6 className="text-body-emphasis fw-bold">Tariffe:</h6>

          {/* Badge unico sopra tutte le tariffe - versione aggiornata */}
          <div className="text-center mb-3">
            <span className="badge bg-success px-3 py-2">
              <i className="bi bi-person-check me-1"></i>
              Solo in presenza
            </span>
          </div>

          <div className="tariffe-list">
            <div className="tariffa-item mb-2 p-3 bg-white rounded shadow-sm">
              <div className="d-flex justify-content-between align-items-center">
                <span className="fw-semibold">Singola seduta</span>
                <span className="fw-bold text-body-emphasis">€ 60</span>
              </div>
            </div>

            <div className="tariffa-item mb-2 p-3 bg-success bg-opacity-10 rounded border border-success border-opacity-25">
              <div className="d-flex justify-content-between align-items-center">
                <span className="fw-semibold">Pacchetto 5 sedute</span>
                <span className="fw-bold text-body-emphasis">€ 300</span>
              </div>
              <small className="text-muted">(€ 60 a seduta)</small>
            </div>

            <div className="tariffa-item mb-3 p-3 bg-primary bg-opacity-10 rounded border border-primary border-opacity-25">
              <div className="d-flex justify-content-between align-items-center">
                <span className="fw-semibold">
                  Pacchetto 10 sedute + 1 omaggio
                </span>
                <span className="fw-bold text-body-emphasis">€ 600</span>
              </div>
              <small className="text-muted">(€ 54.55 a seduta)</small>
            </div>
          </div>

          <div className="promo-text text-center p-3 bg-warning bg-opacity-10 rounded border border-warning border-opacity-25">
            <div className="d-flex align-items-center justify-content-center mb-1">
              <span className="text-warning fs-5 me-2">🎁</span>
              <strong className="text-warning">
                VALUTAZIONE POSTURALE IN OMAGGIO
              </strong>
            </div>
            <small className="text-muted">
              (del valore di € 60) acquistando uno dei pacchetti
            </small>
          </div>

          <div className="mt-3 text-center">
            <button
              className="btn btn-secondary px-4"
              onClick={() =>
                window.open(
                  'https://wa.me/3757481380',
                  '_blank',
                  'noopener,noreferrer'
                )
              }
            >
              <i className="bi bi-calendar-check me-2"></i>
              Prenota ora
            </button>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: 'Personal Training Posturale',
    icon: '💪',
    shortDesc:
      'Un approccio innovativo al fitness che ti insegna a muoverti correttamente e in sicurezza.',
    features: [
      'Esercizi propriocettivi personalizzati',
      'Tecniche integrate Yoga e Pilates',
      'Rinforzo muscolare profondo',
      'Miglioramento equilibrio e coordinazione',
    ],
    longDesc: (
      <div className="modal-content-custom">
        <div className="alert alert-info mb-4">
          <strong>Non è il solito Personal Training!</strong>
        </div>

        <div className="mb-3">
          <button
            className="btn btn-secondary px-4"
            onClick={() =>
              window.open(
                'https://wa.me/3757481380',
                '_blank',
                'noopener,noreferrer'
              )
            }
          >
            <i className="bi bi-calendar-check me-2"></i>
            Prenota ora
          </button>
        </div>

        <p className="text-body">
          Queste sedute hanno l'obiettivo di trasferire, attraverso l'esperienza
          diretta, quelle conoscenze indispensabili per poter muovere in modo
          controllato tutte le parti del corpo, per diventare veri padroni del
          proprio corpo.
        </p>

        <h6 className="text-body-emphasis fw-bold mt-4 mb-3">
          I vantaggi che ne derivano sono molteplici:
        </h6>

        <ul className="mb-4">
          <li className="mb-2 text-body">
            <strong>Esperienza sportiva migliorata:</strong> l'esperienza
            acquisita ti tornerà utile ogni volta che praticherai fitness o
            sport di qualunque tipo, perché saprai come evitare infortuni o
            dolori da movimenti scorretti
          </li>
          <li className="mb-2 text-body">
            <strong>Connessione corpo-mente:</strong> finalmente sentirai la
            connessione con il tuo corpo (tutte le parti) e ti accorgerai – per
            sempre – quando stai mantenendo la postura in modo corretto oppure
            no; saprai come correggere ed evitare i dolori posturali
          </li>
          <li className="mb-2 text-body">
            <strong>Controllo corporeo avanzato:</strong> imparerai a sentire la
            stabilità, a mantenere l'equilibrio, a migliorare la coordinazione,
            la flessibilità, la centratura
          </li>
          <li className="mb-2 text-body">
            <strong>Muscolatura profonda:</strong> riuscirai a controllare la
            muscolatura più profonda, come il pavimento pelvico, il diaframma e
            il muscolo trasverso e imparerai gli esercizi corretti, integrati
            con la respirazione, per mantenerli tonici e funzionali
          </li>
          <li className="mb-2 text-body">
            <strong>Energia e vitalità:</strong> ti accorgerai che senza dolori
            e con i movimenti liberi avrai più energia per andare dove desideri
            e fare quello che ti piace
          </li>
          <li className="mb-2 text-body">
            <strong>Ringiovanimento:</strong> ti sentirai "ringiovanita"
          </li>
        </ul>

        <div className="alert alert-success mt-4">
          <p className="mb-0 text-body">
            <strong>Dopo questo percorso</strong> potrai svolgere in
            tranquillità anche gli allenamenti più svariati in streaming o su
            app, perché avrai le conoscenze per compiere qualunque movimento in
            modo corretto e senza procurarti danni.
          </p>
        </div>

        <div className="mt-4 p-3 bg-body-secondary rounded">
          <h6 className="text-body-emphasis fw-bold mb-3">Tariffe:</h6>

          {/* Badge per modalità disponibili */}
          <div className="text-center mb-3">
            <span className="badge bg-success px-3 py-2 me-2">
              <i className="bi bi-person-check me-1"></i>
              In presenza
            </span>
            <span className="badge bg-info px-3 py-2">
              <i className="bi bi-camera-video me-1"></i>
              Online
            </span>
          </div>

          <div className="tariffe-list">
            {/* Singola seduta */}
            <div className="tariffa-item mb-2 p-3 bg-white rounded shadow-sm">
              <div className="d-flex justify-content-between align-items-center">
                <span className="fw-semibold">Singola seduta</span>
                <span className="fw-bold text-body-emphasis">€ 50</span>
              </div>
              <small className="text-muted">(in presenza o online)</small>
            </div>

            {/* Pacchetto in presenza */}
            <div className="tariffa-item mb-2 p-3 bg-success bg-opacity-10 rounded border border-success border-opacity-25">
              <div className="d-flex justify-content-between align-items-center">
                <span className="fw-semibold">
                  Pacchetto 5 sedute in presenza
                </span>
                <span className="fw-bold text-body-emphasis">€ 250</span>
              </div>
              <small className="text-muted">(€ 50 a seduta)</small>
            </div>

            {/* Pacchetto online */}
            <div className="tariffa-item mb-3 p-3 bg-primary bg-opacity-10 rounded border border-primary border-opacity-25">
              <div className="d-flex justify-content-between align-items-center">
                <span className="fw-semibold">Pacchetto 5 sedute online</span>
                <span className="fw-bold text-body-emphasis">€ 220</span>
              </div>
              <small className="text-muted">(€ 44 a seduta)</small>
            </div>
          </div>

          {/* Promozione */}
          <div className="promo-text text-center p-3 bg-warning bg-opacity-10 rounded border border-warning border-opacity-25">
            <div className="d-flex align-items-center justify-content-center mb-1">
              <span className="text-warning fs-5 me-2">🎁</span>
              <strong className="text-warning">
                VALUTAZIONE POSTURALE IN OMAGGIO
              </strong>
            </div>
            <small className="text-muted">
              (del valore di € 60) acquistando uno dei 2 pacchetti
            </small>
          </div>

          <div className="mt-3 text-center">
            <button
              className="btn btn-secondary px-4"
              onClick={() =>
                window.open(
                  'https://wa.me/3757481380',
                  '_blank',
                  'noopener,noreferrer'
                )
              }
            >
              <i className="bi bi-calendar-check me-2"></i>
              Prenota ora
            </button>
          </div>
        </div>
      </div>
    ),
  },
  {
    title: 'Personal Yoga',
    icon: '🧘‍♀️',
    shortDesc:
      "Percorso dedicato al benessere interiore attraverso l'Hatha Yoga personalizzato.",
    features: [
      'Hatha Yoga personalizzato',
      'Pratica basata sui 4 elementi',
      'Attenzione al respiro e postura',
      'Benefici per mente e corpo',
    ],
    longDesc: (
      <div className="modal-content-custom">
        <div className="alert alert-success mb-4">
          <i className="bi bi-star-fill me-2"></i>
          <strong>
            I segreti millenari di Benessere da sperimentare in modo “personal”
            o da condividere “in duetto”
          </strong>
        </div>

        <div className="mb-3">
          <button
            className="btn btn-secondary px-4"
            onClick={() =>
              window.open(
                'https://wa.me/3757481380',
                '_blank',
                'noopener,noreferrer'
              )
            }
          >
            <i className="bi bi-calendar-check me-2"></i>
            Prenota ora
          </button>
        </div>

        <p className="text-body">
          Questo percorso è dedicato a chi, da sola o in coppia, desidera
          regalarsi un po' di tempo per ritrovare la tranquillità interiore, che
          si riflette in una pace visibile dai lineamenti del viso e dal respiro
          calmo alla fine di ogni seduta.
        </p>

        <p className="text-body">
          L'<strong>Hatha Yoga</strong>, praticabile anche da chi non ha mai
          praticato yoga prima, viene proposto sia in presenza che online con la
          richiesta del minimo indispensabile (un tappetino, un cuscino o un
          paio di mattoncini).
        </p>

        <div className="alert alert-info mb-4">
          <p className="mb-0">
            <strong>Approccio personalizzato:</strong> La mia modalità di
            proporre le pratiche di yoga tiene conto dei 4 elementi, della Luna
            e trae ispirazione dallo Yoga Ratna della Maestra Gabriella Cella,
            in particolare dalle sequenze dello Yoga delle dee, estremamente
            connesse all'essenza femminile.
          </p>
        </div>

        <h6 className="text-body-emphasis fw-bold mt-4 mb-3">
          Le pratiche vengono strutturate per lavorare sui 4 elementi:
        </h6>

        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="card border-body h-100">
              <div className="card-header bg-body-tertiary text-body-emphasis d-flex align-items-center">
                <i className="bi bi-globe me-2"></i>
                <strong>Elemento Terra</strong>
              </div>
              <div className="card-body">
                <p className="card-text small mb-0 text-body">
                  Radicamento, stabilità e rinforzo della struttura pelvica
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="card border-body h-100">
              <div className="card-header bg-body-tertiary text-body-emphasis d-flex align-items-center">
                <i className="bi bi-droplet me-2"></i>
                <strong>Elemento Acqua</strong>
              </div>
              <div className="card-body">
                <p className="card-text small mb-0 text-body">
                  Cambiamento, emozioni e acque del corpo (ritenzione idrica,
                  ecc.)
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="card border-body h-100">
              <div className="card-header bg-body-tertiary text-body-emphasis d-flex align-items-center">
                <i className="bi bi-fire me-2"></i>
                <strong>Elemento Fuoco</strong>
              </div>
              <div className="card-body">
                <p className="card-text small mb-0 text-body">
                  Energia creativa e vitale, calore, agire e trasformazione
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-6 mb-3">
            <div className="card border-body h-100">
              <div className="card-header bg-body-tertiary text-body-emphasis d-flex align-items-center">
                <i className="bi bi-wind me-2"></i>
                <strong>Elemento Aria</strong>
              </div>
              <div className="card-body">
                <p className="card-text small mb-0 text-body">
                  Spiccare il volo, emergere, sollevarsi - per chi lavora troppo
                  di testa e si sente pesante
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="alert alert-primary mt-4">
          <p className="mb-0">
            <strong>Attenzione speciale:</strong> Durante la pratica si dedica
            particolare attenzione e cura al respiro, alla corretta postura, al
            benessere della schiena e di tutta la muscolatura che viene
            gentilmente invitata ad allungarsi e tonificarsi, lasciando una
            sensazione di totale coinvolgimento e rinvigorimento al termine.
          </p>
        </div>

        <div className="mt-4 p-3 bg-body-secondary rounded">
          <h6 className="text-body-emphasis fw-bold">Tariffe:</h6>

          {/* Badge per modalità disponibili */}
          <div className="text-center mb-3">
            <span className="badge bg-success px-3 py-2 me-2">
              <i className="bi bi-person-check me-1"></i>
              In presenza
            </span>
            <span className="badge bg-primary px-3 py-2">
              <i className="bi bi-camera-video me-1"></i>
              Online
            </span>
          </div>

          <div className="tariffe-list">
            {/* Singola seduta */}
            <div className="tariffa-item mb-2 p-3 bg-white rounded shadow-sm">
              <div className="d-flex justify-content-between align-items-center">
                <span className="fw-semibold">Singola seduta</span>
                <span className="fw-bold text-body-emphasis">€ 50</span>
              </div>
              <small className="text-muted">(in presenza o online)</small>
            </div>

            {/* Pacchetto in presenza */}
            <div className="tariffa-item mb-2 p-3 bg-success bg-opacity-10 rounded border border-success border-opacity-25">
              <div className="d-flex justify-content-between align-items-center">
                <span className="fw-semibold">
                  Pacchetto 5 sedute in presenza
                </span>
                <span className="fw-bold text-body-emphasis">€ 250</span>
              </div>
              <small className="text-muted">(€ 50 a seduta)</small>
            </div>

            {/* Pacchetto online */}
            <div className="tariffa-item mb-3 p-3 bg-primary bg-opacity-10 rounded border border-primary border-opacity-25">
              <div className="d-flex justify-content-between align-items-center">
                <span className="fw-semibold">Pacchetto 5 sedute online</span>
                <span className="fw-bold text-body-emphasis">€ 220</span>
              </div>
              <small className="text-muted">(€ 44 a seduta)</small>
            </div>
          </div>

          {/* Promozione */}
          <div className="promo-text text-center p-3 bg-warning bg-opacity-10 rounded border border-warning border-opacity-25">
            <div className="d-flex align-items-center justify-content-center mb-1">
              <span className="text-warning fs-5 me-2">🎁</span>
              <strong className="text-warning">
                VALUTAZIONE POSTURALE IN OMAGGIO
              </strong>
            </div>
            <small className="text-muted">
              (del valore di € 60) acquistando uno dei 2 pacchetti
            </small>
          </div>

          <div className="mt-3 text-center">
            <button
              className="btn btn-secondary px-4"
              onClick={() =>
                window.open(
                  'https://wa.me/3757481380',
                  '_blank',
                  'noopener,noreferrer'
                )
              }
            >
              <i className="bi bi-calendar-check me-2"></i>
              Prenota ora
            </button>
          </div>
        </div>
      </div>
    ),
  },
];
